"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemContentPropTypes = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var Image_1 = require("./Image");
var ItemContent = function (props) {
    var _a;
    return React.createElement("div", { className: 'cdd-item' },
        React.createElement("span", { className: (0, classnames_1.default)('cdd-item__image', { 'cdd-item__image--circular': (_a = props.image) === null || _a === void 0 ? void 0 : _a.circular }) }, props.image && React.createElement(Image_1.default, __assign({}, props.image))),
        React.createElement("div", { className: 'cdd-item__text-wrapper' },
            React.createElement("div", { className: 'cdd-item__left' },
                props.textLeftPrimary && React.createElement("span", { className: 'cdd-item__text' + " " + 'cdd-item__text--primary' }, props.textLeftPrimary),
                props.textLeftSecondary && React.createElement("span", { className: 'cdd-item__text' + " " + 'cdd-item__text--secondary' }, props.textLeftSecondary)),
            React.createElement("div", { className: 'cdd-item__right' },
                props.textRightSecondary && React.createElement("span", { className: 'cdd-item__text' + " " + 'cdd-item__text--secondary' }, props.textRightSecondary),
                props.textRightPrimary && React.createElement("span", { className: 'cdd-item__text' + " " + 'cdd-item__text--primary' }, props.textRightPrimary))));
};
ItemContent.displayName = 'ItemContent';
exports.ItemContentPropTypes = {
    image: PropTypes.shape(Image_1.ImagePropTypes),
    textLeftPrimary: PropTypes.string,
    textLeftSecondary: PropTypes.string,
    textRightPrimary: PropTypes.string,
    textRightSecondary: PropTypes.string,
};
ItemContent.propTypes = exports.ItemContentPropTypes;
exports.default = ItemContent;
